import 'semantic-ui-less/definitions/elements/image.less';import _default from './Image';
export { _default as default };